import Vue from "vue";

import moment from 'moment-timezone';

moment.tz.setDefault('Europe/London');

Vue.use(require('vue-moment'), {
    moment
})

Vue.component('draggable' , require('vuedraggable'));

// UI
Vue.component('icon-calendar', require('./components/icon/icon-calendar.vue').default);
Vue.component('icon-chevron-down', require('./components/icon/icon-chevron-down.vue').default);
Vue.component('icon-chevron-up', require('./components/icon/icon-chevron-up.vue').default);
Vue.component('icon-clock', require('./components/icon/icon-clock.vue').default);
Vue.component('icon-gift', require('./components/icon/icon-gift.vue').default);
Vue.component('icon-hand', require('./components/icon/icon-hand.vue').default);
Vue.component('icon-home', require('./components/icon/icon-home.vue').default);
Vue.component('icon-minus', require('./components/icon/icon-minus.vue').default);
Vue.component('icon-play', require('./components/icon/icon-play.vue').default);
Vue.component('icon-plus', require('./components/icon/icon-plus.vue').default);
Vue.component('icon-rotate-cw', require('./components/icon/icon-rotate-cw.vue').default);
Vue.component('icon-x', require('./components/icon/icon-x.vue').default);
Vue.component('popup-loader', require('./components/icon/popup-loader.vue').default);

// Modules
Vue.component('product-item', require('./components/product.vue').default);
Vue.component('order-line', require('./components/order-line.vue').default);
Vue.component('order-detail', require('./components/order-detail.vue').default);
Vue.component('next-delivery', require('./components/next-delivery.vue').default);
Vue.component('b-collapse-price', require('./components/b-collapse-price.vue').default);
Vue.component('b-collapse-slot', require('./components/b-collapse-slot.vue').default);

// Alert
Vue.component('alert', require('./components/alert/alert.vue').default);

// Components
Vue.component('order', require('./components/order/Order.vue').default);
Vue.component('order-oneoff-new', require('./components/order/EditOneOffOrder.vue').default);
Vue.component('order-oneoff-summary', require('./components/order/SummaryOneOffOrder.vue').default);
Vue.component('order-oneoff-cancel', require('./components/order/CancelOneOffOrder.vue').default);
Vue.component('order-recurring-edit', require('./components/order/EditRecurringOrder.vue').default);
Vue.component('order-recurring-summary', require('./components/order/SummaryRecurringOrder.vue').default);

Vue.component('recurring', require('./components/recurring/OrderRecurring.vue').default);
Vue.component('recurring-new', require('./components/recurring/OrderRecurring-New.vue').default);
Vue.component('recurring-basket', require('./components/recurring/OrderRecurring-Basket.vue').default);
Vue.component('recurring-summary', require('./components/recurring/OrderRecurring-Summary.vue').default);
Vue.component('recurring-pause', require('./components/recurring/OrderRecurring-Pause.vue').default);
Vue.component('recurring-cancel', require('./components/recurring/OrderRecurring-Cancel.vue').default);
Vue.component('recurring-restart', require('./components/recurring/OrderRecurring-Start.vue').default);
Vue.component('daily-simulation', require('./components/recurring/DailySimulation.vue').default);

Vue.component('address-update', require('./components/address/address-update.vue').default);
Vue.component('address-update-form', require('./components/address/address-update-form.vue').default);
Vue.component('address-update-valid', require('./components/address/address-update-valid.vue').default);
Vue.component('address-update-unvalid', require('./components/address/address-update-unvalid.vue').default);

Vue.component('order-address', require('./components/order-address.vue').default);
Vue.component('order-address-fail', require('./components/order-address-fail.vue').default);
Vue.component('order-payment', require('./components/order-payment.vue').default);
Vue.component('order-congrats', require('./components/order-congrats.vue').default);

Vue.component('notice-price-update', require('./components/notice-price-update.vue').default);
